









import Vue from "vue";
import Component from "vue-class-component";
import { AtendimentoService } from "@/services/atendimento.service";
import { Prop, Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value: string | null;
}

@Component
export default class ComboTipoAtendimento extends Vue {
  @Prop() readonly value!: string | null;
  loading = false;
  tipo: ComboItem | null = null;
  itemsTipo: ComboItem[] = [];

  @Watch("value")
  onValueChange(val: string | null) {
    this.tipo = this.itemsTipo.find((x) => x.value == val) ?? null;
  }

  @Watch("tipo")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }

  async fetchTipoAtendimento() {
    this.loading = true;
    const res = await AtendimentoService.ObterTipoAtendimento();
    this.itemsTipo = res.map((x) => ({
      text: x.descricao,
      value: "" + x.idTipoAtendimento,
    }));

    this.itemsTipo.unshift({ text: "", value: null });

    if (this.value) {
      this.tipo = this.itemsTipo.find((x) => x.value == this.value) || null;
    }

    this.loading = false;
  }

  mounted() {
    this.fetchTipoAtendimento();
  }
}
